import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['nameInput', 'nameLabel'];
  static values = {
    overrideRateId: { type: String, default: '' },
  };

  connect() {
    this.nameRequired(!this.overrideRateIdValue);
  }

  overrideRateChosen() {
    this.nameRequired(false);
  }

  overrideRateCleared() {
    this.nameRequired(true);
  }

  /**
   * @param {boolean} value - Whether the name input should be required
   */
  nameRequired(value) {
    const requiredLabel = this.nameLabelTarget.querySelector('.required-field');
    if (requiredLabel) {
      requiredLabel.hidden = !value;
    }

    this.nameInputTarget.required = value;
  }
}
